// extracted by mini-css-extract-plugin
module.exports = {"input_wrapper":"CurrencyPriceInputWrapper_input_wrapper__1wbkZ"};